/* eslint-disable */
import React, {useEffect, useState} from 'react';
import moment from 'moment-timezone';
import sha256 from 'crypto-js/sha256';
import cn from 'classnames';
import IconStar from '@material-ui/icons/Star';
import {useHistory, useRouteMatch} from 'react-router-dom';
import {useDispatch, useSelector} from 'react-redux';
import {TopLineNav} from 'components/layout';
import LinkBack from 'components/LinkBack/styles';
import DashboardContent from 'components/DashboardContent/styles';
import DashboardInner from 'components/DashboardInner/styles';
import {
  Amount,
  OrderDetails,
  OrderDetailsActions,
  OrderDetailsLside,
  OrderDetailsNotes,
  OrderDetailsRside,
  OrderDetailsStatusButtons
} from 'routes/App/BookADriver/Details/styles';
import Subtitle5 from 'components/typography/Subtitle5';
import Subtitle from 'components/typography/Subtitle1';
import {ButtonOutline, ButtonPrimary} from 'components/buttons';
import {FieldTextarea} from 'routes/App/dashboard/styles';
import {phoneFormatForView} from 'helpers/functionUtils/helpFunctions';
import {Body0, Subtitle1} from 'components/typography';
import {
  GET_BAD_DRIVER_RATING,
  GET_BAD_DRIVER_RATING_SUCCESS,
  RUN_BAD_ORDER_DETAIL_JOB,
  STOP_BAD_ORDER_DETAIL_JOB,
  SET_BAD_ORDER_DETAIL_NOTES,
  CLEAR_BAD_ORDER,
  SET_BAD_LARGE_ORDER_STATUS
} from 'store/bookADriver/bookADriverDetails/action';
import {usePrevious} from 'hooks/usePrevious';
import {
  BOOK_A_DRIVER,
  BOOK_A_DRIVER_STATUS,
  isBookADriverRateableStatus
} from 'helpers/constants/bookAdriver';
import {getSessionStorageItem} from 'helpers/sessionStorage';
import SESSION_SAUCE_EMPLOYEE_NAME from 'helpers/sessionStorage/constants';
import Loading from 'components/shared/Utils/Loading';
import IconRedCheck from 'assets/icon-red-check.svg';
import RateDriverModal from 'routes/App/BookADriver/Modals/RateDriverModal';
import DriverRatingViewModal from 'routes/App/BookADriver/Modals/DriverRatingViewModal';

export default function BookADriverDetails() {
  const {order, isLoading, driverRating, getDriverRatingLoading} = useSelector(
    (state) => state.bookADriverOpenDetails
  );

  const {params} = useRouteMatch();

  const dispatch = useDispatch();

  const history = useHistory();

  const [locationState] = useState(location?.state?.windowPosition);

  const {activeLocation, locationId} = useSelector((state) => state.user);

  const locationTimezoneId = activeLocation?.TimezoneId || 'America/New_York';
  const [notes, setNotes] = useState(order?.data?.internal_notes || '');
  const [isRateDriverModalOpen, setIsRateDriverModalOpen] = useState(false);
  const [
    isDriverRatingViewModalOpen,
    setIsDriverRatingViewModalOpen
  ] = useState(false);

  /**
   * Converts UTC date from API to location local time for display.
   * Uses location timezone (IANA) so DST is correct for the date.
   */
  function dateToTimezone(date) {
    if (!date) return date;

    const m = moment.utc(date).tz(locationTimezoneId);
    return m.isValid() ? m.format('MMMM D, h:mm A') : date;
  }
  const prevLocation = usePrevious(locationId);

  useEffect(() => {
    if (prevLocation) {
      redirectToPreviousRoute();
    }
  }, [locationId]);

  useEffect(() => {
    if (order?.data?.internal_notes) {
      setNotes(order?.data?.internal_notes);
    }
  }, [order?.data?.internal_notes]);
  useEffect(() => {
    if (params.id) {
      dispatch(STOP_BAD_ORDER_DETAIL_JOB());
      dispatch(RUN_BAD_ORDER_DETAIL_JOB(params.id));
    }
    return () => {
      dispatch(STOP_BAD_ORDER_DETAIL_JOB());
      dispatch(CLEAR_BAD_ORDER());
    };
  }, []);

  const badDeliveryId = order?.data?.s2e_order_id;

  useEffect(() => {
    if (badDeliveryId) {
      dispatch(GET_BAD_DRIVER_RATING(badDeliveryId));
    } else {
      dispatch(GET_BAD_DRIVER_RATING_SUCCESS(null));
    }
  }, [badDeliveryId]);

  const redirectToPreviousRoute = (state = {}) => {
    history.push(
      params.back === 'history'
        ? '/book-a-driver/history'
        : '/book-a-driver/active',
      state
    );
  };

  const checkIfSauceEmployee = () => {
    return getSessionStorageItem(SESSION_SAUCE_EMPLOYEE_NAME);
  };

  const handleNotes = (e) => {
    setNotes(e.target.value);
  };

  const saveNotes = () => {
    dispatch(
      SET_BAD_ORDER_DETAIL_NOTES({
        id: params.id,
        notes: notes
      })
    );
  };

  const changeStatus = (status) => {
    dispatch(
      SET_BAD_LARGE_ORDER_STATUS({
        id: params.id,
        status
      })
    );
  };

  const sendDriverRateToPostHog = (action, data) => {
    if (window?.posthog) {
      window?.posthog.capture('driver_rate_action', {
        order_id: order?.data?._id || order?.data?.s2e_order_id,
        action,
        rating_type: data?.ratingType,
        selected_reasons: data?.selectedReasons?.join(', '),
        details: data?.details,
        location_id: data?.locationId,
        location_name: data?.locationName,
        timestamp: moment().utc().format()
      });
    }
  };

  const badDeliveryStatus = {
    dispatchVersion: order?.data?.dispatch_version,
    dspOrderId: order?.data?.s2e_meta?.order_id,
    courier: {
      name: order?.data?.s2e_meta?.courier?.name,
      vehicle: order?.data?.s2e_meta?.courier?.vehicle_type,
      deliveryServiceProvider: order?.data?.s2e_meta?.delivery_service
    }
  };

  const showRateDriverButton =
    isBookADriverRateableStatus(
      order?.data?.status,
      badDeliveryStatus?.courier?.name
    ) &&
    order?.data?.reason !== 'LARGE_ORDER' &&
    badDeliveryId;

  return (
    <DashboardContent className='DashboardContent'>
      <TopLineNav>
        <LinkBack
          onClick={() => {
            redirectToPreviousRoute({windowPosition: locationState});
          }}
        >
          Back To All Orders
        </LinkBack>
      </TopLineNav>
      <DashboardInner>
        {isLoading || getDriverRatingLoading ? (
          <Loading />
        ) : (
          <OrderDetails>
            <OrderDetailsLside>
              <div className='marginBottomXl'>
                {order?.data?.s2e_order_id && (
                  <Subtitle5 className='marginBottomXs2 wordWrap'>
                    #{order?.data?.s2e_order_id.substr(-5, 5)}
                  </Subtitle5>
                )}
                <Subtitle1 className='marginBottomXs2'>
                  {order?.data?.status === BOOK_A_DRIVER_STATUS.SCHEDULED && (
                    <span>Scheduled for delivery</span>
                  )}
                  {order?.data?.status === BOOK_A_DRIVER_STATUS.PICKED_UP && (
                    <span>Order was picked up</span>
                  )}
                  {order?.data?.status === BOOK_A_DRIVER_STATUS.ASSIGNED && (
                    <span>Courier has been assigned</span>
                  )}
                  {order?.data?.status === BOOK_A_DRIVER_STATUS.DELIVERED && (
                    <span>Order was delivered</span>
                  )}
                  {order?.data?.status === BOOK_A_DRIVER_STATUS.CANCELLED && (
                    <span>Canceled order</span>
                  )}
                  {order?.data?.status ===
                    BOOK_A_DRIVER_STATUS.DELIVERY_FAILED && (
                    <span>Delivered failed</span>
                  )}
                  {order?.data?.status ===
                    BOOK_A_DRIVER_STATUS.DROPOFF_ENROUTE && (
                    <span>Dropoff enroute</span>
                  )}
                  {order?.data?.status ===
                    BOOK_A_DRIVER_STATUS.PICKUP_ENROUTE && (
                    <span>Pickup enroute</span>
                  )}
                </Subtitle1>
                {order?.data?.s2e_meta?.pickup_eta &&
                  (order?.data?.status === 'picked-up' ||
                    order?.data?.status === 'delivered') && (
                    <Body0>
                      Order was picked up at <br />{' '}
                      <b>{dateToTimezone(order?.data?.s2e_meta?.pickup_eta)}</b>
                    </Body0>
                  )}
              </div>
              <div className='marginBottomXl'>
                <Subtitle className='marginBottomXs2'>Order details</Subtitle>
                <Amount className='marginBottomXs2'>
                  <Subtitle1 className='marginRightXs'>
                    <span>
                      {order?.data?.s2e_meta?.manifest_items[0]?.quantity}{' '}
                      {order?.data?.s2e_meta?.manifest_items[0]?.quantity === 1
                        ? 'item'
                        : 'items'}
                    </span>{' '}
                    • <span>${order?.data?.s2e_meta?.value / 100}</span>
                  </Subtitle1>
                  <Body0>amount</Body0>
                </Amount>
                <Body0 className='marginBottomXs2 Medium'>
                  {order?.data?.s2e_meta?.dropoff.notes && (
                    <span>
                      On arrival: {order?.data?.s2e_meta?.dropoff.notes}
                    </span>
                  )}
                </Body0>
                {order?.data?.s2e_meta?.pickup_eta && (
                  <Body0 className='marginBottomXs2 Medium'>
                    <span className='grey'>Quoted Pickup Time:</span> <br />{' '}
                    {dateToTimezone(order?.data?.s2e_meta?.pickup_eta)}
                  </Body0>
                )}
                {order?.data?.s2e_meta?.dropoff_eta && (
                  <Body0 className='Medium'>
                    <span className='grey'>Quoted Dropoff Time:</span> <br />{' '}
                    {dateToTimezone(order?.data?.s2e_meta?.dropoff_eta)}
                  </Body0>
                )}
                {order?.data?.core_invoice_id && (
                  <Body0 className='marginBottomXs2 Medium'>
                    <span className='grey'>Sauce Order ID:</span> <br />{' '}
                    {order?.data?.core_invoice_id}
                  </Body0>
                )}
              </div>
              <div>
                <Subtitle className='marginBottomXs2'>Customer</Subtitle>
                <Body0 className='Medium'>
                  {order?.data?.s2e_meta?.dropoff.name} <br />
                  <a
                    href={`tel:${order?.data?.s2e_meta?.dropoff?.phone}`}
                    alt='customer-phone-number'
                    onClick={(e) => e.stopPropagation()}
                  >
                    {phoneFormatForView(order?.data?.s2e_meta?.dropoff?.phone)}
                  </a>
                </Body0>
              </div>
            </OrderDetailsLside>
            <OrderDetailsRside>
              {order.data?.status !== 'cancelled' &&
                order?.data?.status !== 'delivered' &&
                order?.data?.reason === 'LARGE_ORDER' &&
                checkIfSauceEmployee() && (
                  <OrderDetailsStatusButtons>
                    <ButtonOutline
                      className='ButtonSmall'
                      type='button'
                      onClick={() => changeStatus('cancelled')}
                    >
                      Cancel order
                    </ButtonOutline>
                    <ButtonPrimary
                      className='ButtonSmall'
                      type='button'
                      onClick={() => changeStatus('delivered')}
                    >
                      <span>Resolve order</span>
                    </ButtonPrimary>
                  </OrderDetailsStatusButtons>
                )}
              {order?.data?.s2e_order_id && order?.data.location_tracking_url && (
                <OrderDetailsActions>
                  <ButtonOutline
                    className='Dark ButtonSmall'
                    data-gtm={'trackDeliveryButton'}
                    onClick={() => {
                      window.open(order?.data?.location_tracking_url, '_blank');
                    }}
                  >
                    Track Delivery
                  </ButtonOutline>
                  {showRateDriverButton && (
                    <ButtonOutline
                      className={cn('ButtonSmall withIcon mL20', {
                        smallP: !driverRating?.id
                      })}
                      onClick={() => {
                        if (driverRating?.id) {
                          setIsDriverRatingViewModalOpen(true);
                        } else {
                          setIsRateDriverModalOpen(true);
                        }
                      }}
                      withIcon
                    >
                      {driverRating?.id ? (
                        <>
                          <img src={IconRedCheck} alt='Check' />
                          <span>Driver Rated</span>
                        </>
                      ) : (
                        <>
                          <IconStar />
                          <span>Rate Driver</span>
                        </>
                      )}
                    </ButtonOutline>
                  )}
                </OrderDetailsActions>
              )}
              <OrderDetailsNotes>
                <Body0 className='marginBottomXs2 Medium'>Internal notes</Body0>
                <FieldTextarea
                  className='FieldTextareaLg marginBottomXs'
                  placeholder='Write your notes here'
                  value={notes}
                  onChange={handleNotes}
                />
                <ButtonPrimary
                  className='ButtonPrimary'
                  style={{maxWidth: '160px'}}
                  onClick={saveNotes}
                  data-gtm={'saveNotes'}
                >
                  <span>Save Notes</span>
                </ButtonPrimary>
              </OrderDetailsNotes>
            </OrderDetailsRside>
          </OrderDetails>
        )}
      </DashboardInner>
      <DriverRatingViewModal
        isOpen={isDriverRatingViewModalOpen}
        onClose={() => setIsDriverRatingViewModalOpen(false)}
        driverName={badDeliveryStatus?.courier?.name}
        rating={driverRating}
        onModify={() => {
          setIsDriverRatingViewModalOpen(false);
          setIsRateDriverModalOpen(true);
        }}
      />
      <RateDriverModal
        isOpen={isRateDriverModalOpen}
        onClose={() => setIsRateDriverModalOpen(false)}
        deliveryStatus={badDeliveryStatus}
        order={order}
        deliveryId={badDeliveryId}
        existingRating={driverRating}
        sendDriverRateToPostHog={sendDriverRateToPostHog}
        activeLocation={activeLocation}
      />
    </DashboardContent>
  );
}
